if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        this.handleErrorMessage();

        // Validate recipient form fields
        if (!this.validateRecipientForm()) {
          console.log('Recipient form is invalid');
          this.handleErrorMessage('Please fill out the required fields.');
          return;
        }
        

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      validateRecipientForm() {
        console.log('Validating recipient form');
        const recipientForm = this.querySelector('recipient-form');
        console.log('Recipient form:', recipientForm);
        if (!recipientForm) return true;
        this.clearErrorMessage(recipientForm);
        const emailInput = recipientForm.querySelector(`#Recipient-email-${recipientForm.dataset.sectionId}`);
        const nameInput = recipientForm.querySelector(`#Recipient-name-${recipientForm.dataset.sectionId}`);
        let isValid = true;
        console.log('Email input:', emailInput);
        console.log('Name input:', nameInput);
    
        if (emailInput && !emailInput.disabled && !emailInput.value) {
          console.log('Email input is empty');
          emailInput.setAttribute('aria-invalid', true);
          emailInput.setAttribute('aria-describedby', `RecipientForm-email-error-${recipientForm.dataset.sectionId}`);
          this.displayErrorMessage(recipientForm, 'Email is required', { email: ['Email is required'] });
          isValid = false;
        }
    
        if (nameInput && !nameInput.disabled && !nameInput.value) {
          console.log('Name input is empty');
          nameInput.setAttribute('aria-invalid', true);
          nameInput.setAttribute('aria-describedby', `RecipientForm-name-error-${recipientForm.dataset.sectionId}`);
          this.displayErrorMessage(recipientForm, 'Name is required', { name: ['Name is required'] });
          isValid = false;
        }
        console.log('Is valid:', isValid);
        return isValid;
      }

      displayErrorMessage(recipientForm, title, body) {
        const errorMessageWrapper = recipientForm.querySelector('.product-form__recipient-error-message-wrapper');
        const errorMessageList = errorMessageWrapper?.querySelector('ul');
        const errorMessage = errorMessageWrapper?.querySelector('.error-message');
        const defaultErrorHeader = errorMessage?.innerText;
    
        errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          errorMessage.innerText = defaultErrorHeader;
          Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${recipientForm.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${recipientForm.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = recipientForm.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (errorMessageList) {
              errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = recipientForm.querySelector(`#Recipient-${key}-${recipientForm.dataset.sectionId}`);
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        } else {
          errorMessage.innerText = body;
        }
      }
    
      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }
    
      clearErrorMessage(recipientForm) {
        const errorMessageWrapper = recipientForm.querySelector('.product-form__recipient-error-message-wrapper');
        const errorMessageList = errorMessageWrapper?.querySelector('ul');
    
        errorMessageWrapper.hidden = true;
    
        if (errorMessageList) errorMessageList.innerHTML = '';
    
        recipientForm.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });
    
        [recipientForm.querySelector(`#Recipient-email-${recipientForm.dataset.sectionId}`),
         recipientForm.querySelector(`#Recipient-name-${recipientForm.dataset.sectionId}`),
         recipientForm.querySelector(`#Recipient-message-${recipientForm.dataset.sectionId}`),
         recipientForm.querySelector(`#Recipient-send-on-${recipientForm.dataset.sectionId}`)].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }
    }
  );
}
